import { render, staticRenderFns } from "./UpdateVersion.vue?vue&type=template&id=0d0fa2ea"
import script from "./UpdateVersion.vue?vue&type=script&lang=js"
export * from "./UpdateVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports